<template>
  <div class="comp-left-side-section">
    <div class="comp-side-tree" v-show="isExpand">
      <!-- 维度选择 -->
      <div v-if="showDimensionSelect" class="dimension-select">
        <div class="text">
          {{ Lang.Text.dimensionDimension }}
        </div>
        <el-select v-model="dimensionType" placeholder="Select" style="width: 100%" @change="handleDimensionChange" >
          <el-option v-for="item in dimensionOptions" :key="item.dictKey" :label="item.i18nValue" :value="item.dictKey" />
        </el-select>
      </div>

      <div v-if="showConsumption && dimensionType == 'AreaEnergy'" class="consumption">
        <div class="consumption-text">
          {{ Lang.Text.dimensionShowConsum }}
        </div>
        <div>
          <el-switch v-model="isShowEnergy" :disabled="dimensionType=='AreaEnergy'"></el-switch>
        </div>
      </div>

      <div v-if="showConsumption && dimensionType == 'AreaEnergy'"  class="divider"></div>

      <!-- 组织选择 -->
      <div v-if="showOrgFilter" class="org-select">
        <div class="left-icon">
          <comp-svg name="tree-node-org"></comp-svg>
        </div>
        <!-- <div class="org-name">
          <div class="text">{{ organizationName || filterTitle }}</div>
        </div> -->
        <!-- 透明组织选择 -->
        <CompTreeSelect
          class="comp-tree-select"
          v-model="organization"
          :tree-data="deptTreeData"
          :treeProps="{
            children: 'children',
            label: 'title',
            value: 'id',
          }"
          node-key="id"
          :filterable="false"
          :clearable="false"
          @change="handleOrganizationChange"
          :suffix-icon="() => {}"
        />
        <div class="right-icon">
          <comp-svg name="icon-down-fill"></comp-svg>
        </div>
      </div>
      <div v-else style="height: 24px;"></div>
      <!-- 搜索过滤 -->
      <div class="side-tree-search-row">
        <el-input 
          class="search-input"
          clearable
          :placeholder="searchPlaceholder"
          @input="handleFilter"
          v-model="filterText"
        >
        </el-input>
        <span class="side-icon-search">
          <comp-svg name="search" size="13px" fill="#616D7C"></comp-svg>
        </span>

        <!-- 维度过滤 -->
        <!-- <div v-if="showDimensionFilter" class="exchange-button">
          <comp-svg :name="filterIcon"></comp-svg>
        </div> -->

        <el-dropdown v-if="showDimensionFilter && billingStatusList.length">
          <div v-if="showDimensionFilter" class="exchange-button" :class="{active: currentFilter != '' }">
            <comp-svg :name="filterIcon"></comp-svg>
          </div>
          <template #dropdown>
            <el-dropdown-menu class="custom-dropdown-menu">
              <el-dropdown-item v-for="(item, i) in billingStatusList" @click="handleFilterSelect(item)"
                >{{ item.i18nValue }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        <div v-else-if="showDimensionFilter" class="exchange-button" :class="{active: currentFilter != '' }">
          <comp-svg :name="filterIcon"></comp-svg>
        </div>
        
      </div>
      <!-- 分割线 -->
      <div class="barrier"></div>
      <!-- 树滚动区域 -->
      <el-scrollbar>
        <div 
          :style="{ height: getScrollBarHeight() }"
          :class="{
            'comp-tree-box': true,
            'comp-tree-select-bill': pageName == 'billingDashboard',
          }"
        >
          <avue-tree
            ref="treeRef"
            node-key="id"
            :option="localTreeOption"
            :data="treeData"
            :highlight-current="false"
            :filter-node-method="filterNode"
            :filter="filterText"
            @node-click="nodeClick"
            @check-change="handleNodeCheck"
          >
            <template #="{ node, data }">
              <span
                :class="{
                  'tree-node-name-row': true,
                  'tree-node-name-row-flex-initial': pageName == 'billingDashboard'
                }"
                :id="node.data.id == (treeData[0]?.id) ? 'treeFirstNodeId' : ''" 
                >
                <!-- 电费看板页 -->
                <span v-if="pageName == 'billingDashboard'" 
                    :class="{
                      'name-right-tag': true,
                      'tag-disabled': data.billingStatus == 1,
                      'tag-success': data.billingStatus == 2,
                      'tag-danger': data.billingStatus == 3,
                    }">
                  {{ node.data.billingStatusName }}
                </span>
                <span class="name-box">
                  <span v-if="pageName == 'deviceManage'" :class="{
                    'status-point': true,
                    offline: data.commStatus == 0,
                    online: data.commStatus == 1,
                    unknown: data.commStatus == 2,
                    disabled: data.commStatus == 3,
                  }">
                    <i class="point"></i>
                  </span>
                  <span v-if="pageName != 'billingDashboard'" class="name-before-icon">
                    <comp-svg :name="getNameBeforeIcon(data)"></comp-svg>
                  </span>
                  <span class="name">{{ data.name || data.title || data.dimensionName }}</span>
                  <comp-svg :name="getNameAfterIcon(data)" size="16px"></comp-svg>
                </span>
                <span class="name-right-icon" v-if="showDotted && node.data.id==(treeData[0]?.id)">
                  <comp-svg name="vertical-dotted" size="16px"></comp-svg>
                </span>
                
              </span>
            </template>
            <template #menu="{ node, data }">
              <!-- 角色管理页 -->
              <div class="tree-menu-box" v-if="pageName=='roleManage' && (permissionObj.add || (permissionObj.edit && node.data.parentId != 0) || (permissionObj.delete && !node.data.hasChildren))">
                <!-- <div v-if="permissionObj.view" class="avue-tree__item" @click="view(node)">{{ Lang.btn.view }}</div> -->
                <div v-if="permissionObj.add" class="avue-tree__item" @click="add(node)">{{ Lang.Button.roleAddRole }}</div>
                <div v-if="permissionObj.edit && node.data.parentId != 0" class="avue-tree__item" @click="edit(node)">{{ Lang.Button.roleEdit }}</div>
                <div v-if="permissionObj.delete && !node.data.hasChildren" class="avue-tree__item" @click="del(node)">{{ Lang.Button.roleDel }}</div>
              </div>
              <!-- 设备管理页 -->
              <div class="tree-menu-box" v-if="pageName=='deviceManage' && ((permissionObj.add && node.data.gatewayType==1) || (permissionObj.add && node.data.gatewayType==2) || (permissionObj.move && [2,3].includes(node.data.gatewayType)))">
                <div v-if="permissionObj.add && node.data.gatewayType==1" class="avue-tree__item" @click="add(node)">{{ Lang.Button.deviceAddGw }}</div>
                <div v-if="permissionObj.add && node.data.gatewayType==2" class="avue-tree__item" @click="add(node)">{{ Lang.Button.deviceAddDevice }}</div>
                <div v-if="permissionObj.move && [2,3].includes(node.data.gatewayType)" class="avue-tree__item" @click="move(node)">{{ Lang.Button.deviceMoveNode }}</div>
              </div>
              <!-- 维度配置页 -->
              <div class="tree-menu-box" v-if="pageName=='dimensionManage' && (permissionObj.addNode || (permissionObj.moveNode && !node.data.isDept) || (permissionObj.deleteNode && !node.data.isDept))">
                <div v-if="permissionObj.addNode" class="avue-tree__item" @click="add(node)">{{ Lang.Button.dimensionAddNode }}</div>
                <div v-if="permissionObj.moveNode && !node.data.isDept" class="avue-tree__item" @click="move(node)">{{ Lang.Button.dimensionMoveNode }}</div>
                <div v-if="permissionObj.deleteNode && !node.data.isDept" class="avue-tree__item" @click="del(node)">{{ Lang.Button.dimensionDelete }}</div>
              </div>
              <!-- 用户管理页 -->
              <div class="tree-menu-box" v-if="pageName=='userManage' && node.level != 1">
                <div class="avue-tree__item" @click="view(node)">{{ Lang.Button.userOrgDetail }}</div>
                <div v-if="permissionObj.edit" class="avue-tree__item" @click="edit(node)">{{ Lang.Button.userOrgEdit }}</div>
                <div v-if="permissionObj.delete" class="avue-tree__item" @click="del(node)">{{ Lang.Button.userOrgDelete }}</div>
              </div>
            </template>

          </avue-tree>
        </div>
      </el-scrollbar>

      <div v-if="showIncludeSubNode || (showBottomAdd && permissionObj.add)" class="empty-div" style="height: 85px;"></div>
      <!-- 是否显示底部 包含子节点 -->
      <div v-if="showIncludeSubNode" class="side-bottom-box">    
        <div class="include-box">
          <span style="margin-top: 4px">
            <comp-svg name="tree-node-triangle"></comp-svg>
          </span>
          <span class="include-text">{{ Lang.Text.basicTxIncludeSub }}</span>
          <el-switch v-model="localIncludeSubNodes" @change="handleIncludeSubNodesChange"></el-switch>
        </div>
      </div>

      <!-- 是否显示底部 添加按钮 -->
      <div v-if="showBottomAdd && (permissionObj.addNode || permissionObj.add)" class="side-bottom-box">    
        <div class="add-box" @click="bottomAdd()">
          <span class="icon"><comp-svg name="add"></comp-svg></span>
          <span class="add-text">{{ bottomAddText }}</span>
        </div>
      </div>

    </div>

    <!-- 收起、展开按钮 -->
    <div class="collapse-or-expand" @click="toggleExpand"
      :class="{
        reposition: !isExpand
      }"
    >
      <div v-if="isExpand" class="collapse">
        <comp-svg name="collapse"></comp-svg>
      </div>
      <div v-else class="expand">
        <comp-svg name="expand"></comp-svg>
      </div>
    </div>



  </div>

</template>
<script setup>
import { ref, watch, defineExpose, onMounted } from 'vue';
import { Lang } from '@/lang/lang';
import { debounce } from 'lodash-es'; // 或者使用其他防抖方法
import CompTreeSelect from '@/components/comp-tree-select/index.vue';
import { getDeptTree } from '@/api/system/dept';
import { mapGetters } from 'vuex';
import { filterDollarKeys, filterByGatewayType, removeParentZeroNodes } from '@/utils/util';
import { getDictionary } from '@/api/system/dict';




// Props
const props = defineProps({
  treeOption: {
    type: Object,
    default() {
      return {
      }
    }
  },
  permissionObj: {
    type: Object,
    default() {
      return {
      }
    }
  },
  filterTitle: {
    type: String,
    default: Lang.Text.dimensionAllAuthNode
  },
  filterIcon: {
    type: String,
    default: 'exchange'
  },
  pageName: {
    type: String,
    default: ''
  },
  searchPlaceholder: {
    type: String,
    default: Lang.Button.modelSearch
  },
  bottomAddText: {
    type: String,
    default: Lang.btn.add
  },
  treeData: {
    type: Array,
    default() {
      return []
    }
  },
  showDimensionFilter: { // 展示维度过滤器按钮
    type: Boolean,
    default: false
  },
  showConsumption: { //
    type: Boolean,
    default: false
  },
  showOrgFilter: { // 展示组织过滤器
    type: Boolean,
    default: false
  },
  showDimensionSelect: { // 展示维度选择
    type: Boolean,
    default: false
  },
  showBottomAdd: {
    type: Boolean,
    default: false
  },
  showIncludeSubNode: {
    type: Boolean,
    default: false
  },
  showDotted: { // 展示名称后的...
    type: Boolean,
    default: false
  },
  includeSubNodes: {
    type: Boolean,
    default: false
  },
});

// 引入 userInfo
const userInfo = mapGetters(['userInfo'])


const emit = defineEmits([
  'nodeClick',
  'checkChange',
  'filterNodeMethod',
  'update:includeSubNodes',
  'update:treeOption',
  'bottomAdd',
  'add', 'move', 'edit', 'view', 'delete', 'getData',
  'updateSideTree',
  'dimensionChange',
  'organizationChange',
  'filterChange',
  'toggle',
]);

const add = (node) => emit('add', node);
const edit = (node) => emit('edit', node);
const view = (node) => emit('view', node);
const del = (node) => emit('delete', node);
const move = (node) => emit('move', node);
const bottomAdd = () => emit('bottomAdd');

const treeRef = ref(null)
const currentNode = ref(null);

const billingStatusList = ref([]) // 开户状态
const deptTreeData = ref([]) // 部门树
const dimensionOptions = ref([]) // 维度下拉

const dimensionType = ref('AreaEnergy')
const isShowEnergy = ref(true)
const isExpand = ref(true)
const filterText = ref('')
const filterTextPlaceholder = ref('')
const currentFilter = ref('');
const organization = ref('')
// const organizationName = ref('')
const isEmiting = ref(false); // 用于防止重复触发事件
const isExactQuery = ref(false); // 是否精确查询

// 初始化本地状态
const localIncludeSubNodes = ref(props.includeSubNodes);
const localTreeOption = ref({
  ...props.treeOption,
  // checkStrictly: !props.includeSubNodes
  checkStrictly: true
});
// 监听 props 变化
watch(() => props.includeSubNodes, (newVal) => {
  localIncludeSubNodes.value = newVal;
  localTreeOption.value = {
    ...props.treeOption,
    // checkStrictly: !newVal
  };
});

watch(() => props.treeOption, (newVal) => {
  localTreeOption.value = {
    ...newVal,
    // checkStrictly: !localIncludeSubNodes.value
  };
});

watch(
  () => props.treeData,
  (newVal) => {
    if (newVal && newVal.length > 0) {
      if (['deviceManage'].includes(props.pageName)) {
        // 
        console.log('设备管理页，自动展开到第0级')
      } else {
        setTimeout(() => {
          expandToLevel(props.treeOption?.expandLevel || 3);
        }, 300);
      }
    }
  },
  { immediate: true }
);

function getScrollBarHeight() {
  let height = 126;
  if (props.showOrgFilter) {
    height += 52;
  } else {
    height += 24;
  }
  if (props.showBottomAdd && (props.permissionObj.addNode || props.permissionObj.add)) {
    height += 82;
  } else if (props.showIncludeSubNode || (props.showBottomAdd && props.permissionObj.add)) {
    height += 82;
  }
  if (props.showDimensionSelect) {
    height += 84;
  }
  const clientHeight = document.body.clientHeight;
  console.log('滚动区增高度', height, clientHeight)
  const scrollHeight = clientHeight - height;
  return `${scrollHeight}px`;
}

function onlyCancelCheckedCurrentNodeAndSubNodes(data) {
  const checkedKeys = treeRef.value?.getCheckedKeys() || [];
  setDefaultChecked([])
  checkAllSubNodes(data.id, false);
  // 收集子节点keys
  const uncheckedKeys = [data.id]; // 初始化为当前节点的 ID
  const collectKeys = (children) => {
    children.forEach((child) => {
      uncheckedKeys.push(child.id); // 收集子节点的 ID
      if (child.children && child.children.length > 0) {
        collectKeys(child.children); // 递归处理子节点
      }
    });
  };
  if (data.children && data.children.length > 0) {
    collectKeys(data.children);
  }
  const otherCheckedKeys = []
  checkedKeys.forEach((key) => {
    if (!uncheckedKeys.includes(key)) {
      otherCheckedKeys.push(key); // 添加当前节点的 ID
    }
  });
  setDefaultChecked(otherCheckedKeys) // 保留其它选中的节点
}

function toggleChecked(data, node) {
  if (node && !node.checked) {
    treeRef.value?.setChecked(data.id, true, false); // 只选中当前节点
  } else {
    treeRef.value?.setChecked(data.id, false, false); // 消选中当前节点
  }
}

function nodeClick(data, node, uncheckSubNodes) {

  console.log('触发nodeClick')
  currentNode.value = data;
  updatePlaceholder();
  // 检查节点是否已选中
  const isChecked = treeRef.value?.getCheckedKeys()?.includes(data.id);
  if (localIncludeSubNodes.value) {
    // 包含子节点的情况下，判断当前节点是否已选中
    if (isChecked) {
      // 如果已选中，则取消选中及子节点
      if (data.children?.length) {
        onlyCancelCheckedCurrentNodeAndSubNodes(data);
      } else { // 如果没有子节点，则选中当前节点
        toggleChecked(data, node)
      }
    } else { 
      // 如果未选中，则选中节点
      if (data.children?.length) {
        if (uncheckSubNodes === 'uncheckSubNodes') { // 入口不一样
          // 取消选中当前节点及子节点
          onlyCancelCheckedCurrentNodeAndSubNodes(data);
        } else { // 控制只选当前
          const checkedKeys = treeRef.value?.getCheckedKeys() || [];
          const checkedKeysWithoutCurrent = checkedKeys.filter((key) => key !== data.id);
          // setDefaultChecked([...checkedKeysWithoutCurrent, data.id])
          treeRef.value?.setChecked(data.id, true, false);
        }
      } else { // 如果没有子节点
        toggleChecked(data, node)
      }
    }
  } else {
    // 不包含子节点的情况下，判断当前节点是否已选中
    if (isChecked) {
      if (data.children?.length) {
        treeRef.value?.setChecked(data.id, false, false); // 只取消选中当前节点
      } else { // 如果没有子节点
        toggleChecked(data, node)
      }
    } else {
      if (data.children?.length) {
        treeRef.value?.setChecked(data.id, true, false); // 只选中当前节点
      } else { // 如果没有子节点
        toggleChecked(data, node)
      }
    }
  }
  const checkedNodes = treeRef.value?.getCheckedNodes() || [];

  if (isEmiting.value) {
    console.log('正在发射事件，忽略当前勾选操作 nodeClick');
    return;
  }
  emit('nodeClick', {
    data,
    parentData: node?.parent?.data || {},
    checkedNodes,
  })
  isEmiting.value = true; // 标记为正在发射事件
  setTimeout(() => {
    isEmiting.value = false; // 事件发射完成后重置标记
  }, 500); // 设置一个合理的延时，确保事件处理完成
}

function checkAllSubNodes(checkNode, isChecked) {
  const allCheckedKeys = [];
  if (localIncludeSubNodes.value) { // 如果包含子节点，自动把子节点勾选

    const checkAllChildren = (node) => {
      const checkNode = [];
      const collectKeys = (children) => {
        children.forEach((child) => {
          checkNode.push(child.id); // 收集子节点的 ID
          if (child.children && child.children.length > 0) {
            collectKeys(child.children); // 递归处理子节点
          }
        });
      };

      if (node.children && node.children.length > 0) {
        collectKeys(node.children);
      }

      return checkNode;
    };

    // 获取当前所有勾选的节点
    const checkedNodes = treeRef.value?.getCheckedNodes() || [];

    checkedNodes.forEach((node) => {
      if (isChecked) {
        allCheckedKeys.push(node.id); // 添加当前节点的 ID
        const childKeys = checkAllChildren(checkNode); // 获取子节点的 ID
        allCheckedKeys.push(...childKeys);

        if (checkNode.children && checkNode.children.length > 0) {
          const childKeys = checkAllChildren(node); // 获取子节点的 ID
          allCheckedKeys.push(...childKeys);
        }
      } else {
        if (checkNode.id != node.id) {
          allCheckedKeys.push(node.id);
        }
      }
    });

    // 更新树的勾选状态
    treeRef.value?.setCheckedKeys(allCheckedKeys);
    treeRef.value?.setChecked(checkNode.id, isChecked, true);
  }
}



// 新增：处理节点勾选事件
const handleNodeCheck = debounce(function(checkNode, checked) {

  // 获取当前所有勾选的节点
  console.log('触发nodeCheck')
  if (!checked && localIncludeSubNodes.value) { // 通过点击方法取消
    nodeClick(checkNode, false, 'uncheckSubNodes')
    return;
  } else {

  
    const allCheckedKeys = [];
    if (localIncludeSubNodes.value) { // 如果包含子节点，自动把子节点勾选

      const checkAllChildren = (node) => {
        const checkNode = [];
        const collectKeys = (children) => {
          children.forEach((child) => {
            checkNode.push(child.id); // 收集子节点的 ID
            if (child.children && child.children.length > 0) {
              collectKeys(child.children); // 递归处理子节点
            }
          });
        };

        if (node.children && node.children.length > 0) {
          collectKeys(node.children);
        }

        return checkNode;
      };

      // 获取当前所有勾选的节点
      const checkedNodes = treeRef.value?.getCheckedNodes() || [];

      checkedNodes.forEach((node) => {
        if (checked) {
          allCheckedKeys.push(node.id); // 添加当前节点的 ID
          if (node.id == checkNode.id) { // 只收取当前节点的子节点
            const childKeys = checkAllChildren(checkNode); // 获取子节点的 ID
            allCheckedKeys.push(...childKeys);
          }
          // 如果当前节点有子节点，则也收集子节点的 ID
          if (checkNode.children && checkNode.children.length > 0) {
            if (node.id == checkNode.id) {
              const childKeys = checkAllChildren(node); // 获取子节点的 ID
              allCheckedKeys.push(...childKeys);
            }
          }
        } else {
          if (checkNode.id != node.id) {
            allCheckedKeys.push(node.id);
          }
        }
      });

      // 更新树的勾选状态
      treeRef.value?.setCheckedKeys(allCheckedKeys);
      if (!checked) {
        treeRef.value?.setChecked(checkNode.id, false, true); // 取消当前及其子级
      }
    }

    const checkedNodes = treeRef.value?.getCheckedNodes() || [];
    // 触发 nodeClick 事件，传递勾选节点信息

    if (isEmiting.value) {
      console.log('正在发射事件，忽略当前勾选操作 nodeCheck');
      return;
    }
    emit('checkChange', {
      checkedKeys: allCheckedKeys,          // 当前操作的节点
      checkedNodes,            // 所有已勾选的节点
      checked: checked,
      eventType: 'check'       // 标识事件来源是勾选
    });
    isEmiting.value = true; // 标记为正在发射事件
    setTimeout(() => {
      isEmiting.value = false; // 事件发射完成后重置标记
    }, 500); // 设置一个合理的延时，确保事件处理完成
  }
}, 300) // 300毫秒内只执行最后一次

// 防抖处理输入事件
const handleFilter = debounce((val) => {
  isExactQuery.value = false;
  treeRef.value && treeRef.value.filter( val || filterText.value);
}, 300);

const exactQuery = (val) => {
  isExactQuery.value = true;
  treeRef.value && treeRef.value.filter(val);
}

// 自定义过滤方法
const filterNode = (value, data) => {
  if (!value) return true;
    // 默认实现：检查 name 字段是否包含搜索文本
  if (props.filterNodeMethod) {
    return props.filterNodeMethod(value, data)
  } else {
    const valLowerCase = value.toLowerCase();
    if (isExactQuery.value) {
      // 精确匹配
      return (
        data.name && data.name == value
        || data.assetId && data.assetId == value
        || data.sn && data.sn == value
        || data.billingStatusName && data.billingStatusName == value
        || data.title && data.title == value
        || data.modelName && data.modelName == value
      );
    }
    return (
      data.name && data.name.toLowerCase().includes(valLowerCase)
      || data.assetId && data.assetId.toLowerCase().includes(valLowerCase)
      || data.sn && data.sn.toLowerCase().includes(valLowerCase)
      || data.billingStatusName && data.billingStatusName.toLowerCase().includes(valLowerCase)
      || data.title && data.title.toLowerCase().includes(valLowerCase)
      || data.modelName && data.modelName.toLowerCase().includes(valLowerCase)
    );
  }
}

const handleDimensionChange = (val) => {
  currentNode.value = null;
  emit('dimensionChange', val)
}

// 节点前图标
const getNameBeforeIcon = (data) => {
  if (props.pageName == 'deviceManage') {
    if (data.gatewayType == 1) {
      return 'tree-node-router';
    }
    if (data.gatewayType == 2) {
      return 'tree-node-gateway';
    }
    if (data.gatewayType == 3) { 
      return 'tree-node-device';
    }
  } else if (['energyAnalysis', 'historyData', 'dimensionManage'].includes(props.pageName)) {
    if (data.isDept == 1) {
      return 'tree-node-org';
    }
    return 'simple-tree-node'
  } else if (['userManage', 'roleManage'].includes(props.pageName)) {
    return 'tree-node-org'; // 节点都是部门
  } else if (['environmentalAnalysis', 'photovoltaicStation'].includes(props.pageName)) {
    if (data.isDept == 1) {
      return 'tree-node-org';
    }
    return 'simple-tree-node'
  } else {
    if (data.isDept == 1) {
      return 'tree-node-org';
    }
    return 'simple-tree-node'
  }
}

// 
const updatePlaceholder = () => {
  const gatewayType = currentNode.value?.gatewayType;
  if (gatewayType == 1) {
    return Lang.Text.deviceSearchSn;
  }
  if (gatewayType == 2) {
    return Lang.Text.deviceSearchSn;
  }
  if (gatewayType == 3) { 
    return Lang.Text.deviceSearchSn;
  }
}

const getNameAfterIcon = (data) => {
  if (props.pageName == 'deviceManage') {
   if (data.items) {
    return 'link'
   }
  } else if (['dimensionManage', 'historyData'].includes(props.pageName)) {
    if (data.rtuId) {
      return 'link';
    }
  } else {
    return '';
  }
}

function handleIncludeSubNodesChange(val) {
  // 更新本地开关状态
  localIncludeSubNodes.value = val;
  
  // 只更新 checkStrictly 属性，保持其他属性不变
  const updatedOption = {
    ...props.treeOption,  // 保留原有所有属性
    // checkStrictly: !val   // 只更新 checkStrictly
  };
  
  // 如果需要通知父组件
  emit('update:treeOption', updatedOption);
  emit('update:includeSubNodes', val);
}

function toggleExpand() {
  isExpand.value = !isExpand.value;
  emit('toggle', isExpand.value)
}

function getDimensionData() {
  getDictionary({code: 'Dimension'}).then(res => {
    dimensionOptions.value = res.data.data;
    dimensionType.value = props.dimensionType || dimensionOptions.value[0].dictKey;
    emit('dimensionChange', dimensionType.value)
  })
}

// 获取开户状态
function getBillingStatusList() {
  getDictionary({code: 'billingStatus'}).then(res => {
    const data = res.data.data;
    data.unshift({
      dictKey: 'all',
      i18nValue: Lang.Text.modelAll,
    })
    billingStatusList.value = data;
    // data.forEach(item => {
    //   if (item.dictKey == '2') {
    //     setTimeout(() => {
    //       exactQuery(item.i18nValue); // 自动过滤展示开户状态为2的
    //     }, 200)
    //   }
    // });
    console.log('获取到的开户状态', data)
  })
}
// 处理过滤器选择
function handleFilterSelect(item) {
  emit('filterChange', item)
  // let filterTextValue = item.i18nValue;
  // currentFilter.value = item.i18nValue; // 更新当前过滤器
  // if (item.dictKey == 'all') {
  //   filterTextValue = '';
  // }
  // // 触发过滤
  // exactQuery(filterTextValue);
}


// 获取部门树
function getDeptTreeData() {
  const param = {
    tenantId: userInfo.tenant_id,
    deptId: userInfo.deptId,
  }
  getDeptTree(param).then(res => {
    const originData = res.data.data || []
    const data = removeParentZeroNodes(res.data.data);
    // console.log('处理掉0级后的组织数据', data)
    // 把所有授权组织作为第一个节点
    const itemZero = originData[0] || {}
    data.unshift({
      id: itemZero?.id || '',
      name: Lang.Text.dimensionAllAuthNode,
      title: Lang.Text.dimensionAllAuthNode,
      isDept: 1,
      children: [],
      key: itemZero?.key || '',
      rtuId: itemZero?.rtuId || '',
      parentId: itemZero?.parentId || '',
      items: itemZero?.items || [],
    })
    deptTreeData.value = data;
    organization.value = itemZero.id;
    // if (data.length) {
    //   const itemZero = data[0] || {}
    //   organizationName.value = itemZero.title || itemZero.name;
    // }
  })
}

function handleOrganizationChange(val, node) {
  // const data = node.data || {}
  // organizationName.value = data.title || data.name;
  currentNode.value = ''; // 清空当前节点 如果是组织变更，则需要自动选中第一条
  emit('organizationChange', val)
}


function setCurrentKey (id) {
  if (treeRef.value) {
    treeRef.value.setCurrentKey(id); // 高亮
  }
}
function setCurrentNode (node) {
  if (treeRef.value) {
    treeRef.value.setCurrentNode(node); // 高亮
  }
}

function setDefaultChecked(keys) {
  // keys 是一个数组，包含需要默认勾选的节点的 key 值
  if (treeRef.value) {
    treeRef.value.setCheckedKeys(keys); // 调用 avue-tree 的 setCheckedKeys 方法
  }
}


function autoClickFirstNode() {
  const item = props.treeData[0] || {};
  if (currentNode.value) {
    if (localTreeOption.value.multiple) { // 多选
      setDefaultChecked([currentNode.value.id])
    } else {
      nodeClick(currentNode.value)
    }
    setCurrentKey(currentNode.value.id)
  } else if (item.id && !currentNode.value) {
    console.log('comp-side-tree当前被删除后自动选中第一条', item)
    if (localTreeOption.value.multiple) { // 多选
      setDefaultChecked([item.id])
    } else {
      nodeClick(item)
    }
    setCurrentKey(item.id)
  }
}
// 新增方法：展开指定层级的节点
const expandToLevel = (maxLevel = 3) => {
  const expandedKeys = []; // 用于存储前三级节点的 ID

  const collectKeys = (nodes, currentLevel) => {
    if (!Array.isArray(nodes)) return;

    nodes.forEach((node) => {
      // 如果当前层级小于等于最大层级，记录节点 ID
      if (currentLevel <= maxLevel) {
        expandedKeys.push(node.id);
      }

      // 如果有子节点，递归处理
      if (node.children && node.children.length > 0) {
        collectKeys(node.children, currentLevel + 1);
      }
    });
  };

  // 开始递归收集节点 ID
  collectKeys(props.treeData, 1);
  // console.log('expandedKeys', expandedKeys)
  // 将收集到的 ID 赋值到 defaultExpandedKeys
  localTreeOption.value.defaultExpandedKeys = expandedKeys;
};

function updateCurrentNode(data) {
  currentNode.value = data;
}

onMounted(() => {
  if (props.showDimensionSelect) {
    getDimensionData()
  }
  autoClickFirstNode()
  if (props.showOrgFilter) {
    getDeptTreeData()
  }
  if (props.pageName == 'billingDashboard') {
    getBillingStatusList()
  }
  // 添加一个延迟，确保树渲染完成后再展开
})

defineExpose({
  treeRef,
  setCurrentKey,
  setCurrentNode,
  setDefaultChecked,
  nodeClick,
  autoClickFirstNode,
  expandToLevel,
  updateCurrentNode,
})

</script>